<script lang="ts">
	import { createDroppable, type CreateDroppableInput } from "@dnd-kit/svelte";
	import { flip } from "svelte/animate";
	import { SocialLinkType, type SocialLink } from "#gen/bundles/v1/contact_pb.js";
	import SocialLinkItem from "#lib/components/flow/editor/content/contact/SocialLinkItem.svelte";
	import type { Snippet } from "svelte";

	interface Props extends CreateDroppableInput {
		links: SocialLink[];
		errors?: unknown[];
		onInput?: (link: SocialLink, index: number) => void;
		onChange?: (link: SocialLink, index: number) => void;
		onRemove?: (link: SocialLink, index: number) => void;
		footer?: Snippet;
	}

	let { links, errors, onInput, onChange, onRemove, footer, ...rest }: Props = $props();

	const { attach } = $derived(createDroppable(rest));
</script>

<div {@attach attach} class="social-links-dnd-container flex flex-col gap-4">
	<div class="flex flex-col gap-4">
		{#each links as link, index (`${SocialLinkType[link.type]}:${link.id}`)}
			<div animate:flip={{ duration: 200, delay: 0 }}>
				<SocialLinkItem id={`${SocialLinkType[link.type]}:${link.id}`} {link} {index} error={errors?.[index]} {onInput} {onChange} {onRemove} />
			</div>
		{/each}
	</div>
	{@render footer?.()}
</div>

<style>
	.social-links-dnd-container :global([data-dnd-placeholder]) {
		visibility: visible !important;
		background-color: var(--color-primary-100);
		border-radius: 0.5rem;
	}

	.social-links-dnd-container :global([data-dnd-placeholder] *) {
		visibility: hidden !important;
	}
</style>
